import { persisted } from './persisted';

export default persisted<number>('obligationId', 0, { storage: 'session' });
